import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import { getPathByArray } from '@utils/simejiPath';
import React from 'react';

export interface Props {
  data: ISimejiItem | any;
  color?: string;
  eyelidColor?: string;
  skinColor?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Eyelids({ data, color, eyelidColor, skinColor }: Props) {
  const { eyesStrokeWidth, eyeBrowStrokeWidth } = data;
  const { eyesPath, eyelidsPath, eyeBrowPath } = getPathByArray({ data });

  return (
    <>
      {/* 왼눈 --------------------------------- */}
      <svg
        x="21"
        y="51"
        width="25"
        height="20"
        viewBox="0 0 25 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <g
          className="eyelid eyelid-left"
          transform="matrix(-1, 0, 0, 1, 25, 0)"
        >
          {/* 눈두덩이 */}
          <path
            d="M 4 16 C 10 11 20 13 24 14 
            C 24 8 19 2 10 2 
            C 2 3 -2 22 4 16 Z"
            fill={skinColor}
          />
          {/* 눈꺼풀 */}
          <path
            className="mainEyelid"
            d={eyesPath}
            stroke={color}
            strokeWidth={eyesStrokeWidth || 4}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* 쌍커풀 */}
          <path
            className="doubleEyelid"
            d={eyelidsPath}
            stroke={eyelidColor}
            strokeWidth={1}
            strokeLinecap="round"
            fill="none"
            strokeLinejoin="round"
          />
        </g>
      </svg>

      {/* 오른눈 --------------------------------- */}
      <svg
        x="54"
        y="51"
        width="25"
        height="20"
        viewBox="0 0 25 20"
        fill="none"
        style={{ overflow: 'visible' }}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* 오른눈 */}
        <g className="eyelid eyelid-right">
          {/* 눈두덩이 */}
          <path
            d="M 4 16 C 10 11 20 13 24 14 
            C 24 8 19 2 10 2 
            C 2 3 -2 22 4 16 Z"
            fill={skinColor}
          />
          {/* 눈꺼풀 */}
          <path
            className="mainEyelid"
            d={eyesPath}
            stroke={color}
            strokeWidth={eyesStrokeWidth || 4}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* 쌍커풀 */}
          <path
            className="doubleEyelid"
            d={eyelidsPath}
            stroke={eyelidColor}
            strokeWidth={1}
            strokeLinecap="round"
            fill="none"
            strokeLinejoin="round"
          />
        </g>
      </svg>

      {/* 눈썹 --------------------------------- */}
      {/* 왼쪽 */}
      <svg
        x="21"
        y="51"
        width="25"
        height="20"
        viewBox="0 0 25 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <g className="eyebrow eyebrow-left">
          <path
            d={eyeBrowPath}
            stroke={color}
            strokeWidth={eyeBrowStrokeWidth || 3}
            strokeLinecap="round"
          />
        </g>
      </svg>

      {/* 오른쪽 */}
      <svg
        x="54"
        y="51"
        width="25"
        height="20"
        viewBox="0 0 25 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <g className="eyebrow eyebrow-right">
          <path
            d={eyeBrowPath}
            stroke={color}
            strokeWidth={eyeBrowStrokeWidth || 3}
            strokeLinecap="round"
          />
        </g>
      </svg>
    </>
  );
}

export default Eyelids;
